import React from 'react';
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { Combobox, ComboboxInput } from '@headlessui/react';
import SpinnerIcon from '@components/atoms/SpinnerIcon';
import clsx from 'clsx';

interface IProps {
    initialValue: string;
    placeholder: string;
    isLoading: boolean;
    onSearch: (search: string) => void;
}

export default function SearchInputField(props: IProps) {
    const { initialValue, placeholder, isLoading, onSearch } = props;
    const [searchTextInputValue, setSearchTextInputValue] = React.useState<string>(initialValue);

    React.useEffect(() => {
        setSearchTextInputValue(initialValue);
    }, [initialValue]);

    const handleSearch = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            onSearch(searchTextInputValue);
        }
    };

    const handleClear = () => {
        setSearchTextInputValue('');
        onSearch('');
    };

    return (
        <Combobox>
            <div className='relative bg-white rounded border flex flex-row justify-between items-center px-2'>
                <MagnifyingGlassIcon className='pointer-events-none h-4 w-4 text-gray-400' />
                <ComboboxInput
                    value={searchTextInputValue}
                    autoFocus
                    className='h-8 w-full border-0 bg-transparent text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm'
                    placeholder={placeholder}
                    onChange={(event) => setSearchTextInputValue(event.currentTarget.value)}
                    onKeyDown={handleSearch}
                    autoComplete='off'
                />
                <div className={clsx('rounded h-6 w-6 p-1 text-gray-400 my-auto', {'cursor-pointer hover:text-gray-600 hover:bg-gray-300': !isLoading})}>
                    {isLoading ? <SpinnerIcon /> : <XMarkIcon onClick={handleClear} />}
                </div>
            </div>
        </Combobox>
    );
}
